// extracted by mini-css-extract-plugin
export default {"overlay":"wu-z","bodyOpen":"xu-z","content":"yu-z","header":"zu-z","close":"Au-z","closeNoHeading":"Bu-z"};